// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-Questions-questions {\n  line-height: 1.3;\n}\n.x-Questions-questionsLabel {\n  font-weight: bold;\n}\n", ""]);
// Exports
exports.locals = {
	"questions": "x-Questions-questions",
	"questionsLabel": "x-Questions-questionsLabel"
};
module.exports = exports;
